export default {
  path: '/admin',
  component: {
    render: h => h('router-view'),
  },
  children: [
    {
      path: '/admin/system-management',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/admin/system-management/menu',
          component: () => import('@/views/admin/system-management/menu/menu'),
        },
        {
          path: '/admin/system-management/role',
          component: () => import('@/views/admin/system-management/role/role'),
        },
        {
          path: '/admin/system-management/business-role',
          component: () =>
            import(
              '@/views/admin/system-management/business-role/business-role'
            ),
        },
        {
          path: '/admin/system-management/user',
          component: () => import('@/views/admin/system-management/user/user'),
        },
        {
          path: '/admin/system-management/project-management',
          component: () =>
            import('@/views/admin/system-management/project-management/index'),
        },
      ],
    },
    {
      path: '/admin/system-setting',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/admin/system-setting/parameter-setting',
          component: () =>
            import(
              '@/views/admin/system-setting/parameter-setting/parameter-setting'
            ),
        },
        {
          path: '/admin/system-setting/value-setting',
          component: () =>
            import('@/views/admin/system-setting/value-setting/value-setting'),
        },
        {
          path: '/admin/system-setting/fx',
          component: () => import('@/views/admin/system-setting/fx/fx'),
        },
        {
          path: '/admin/system-setting/mail',
          component: () => import('@/views/admin/system-setting/mail/mail'),
        },
        {
          path: '/admin/system-setting/mail-address-setting',
          component: () =>
            import('@/views/admin/system-setting/mail-address-setting'),
        },
        {
          path: '/admin/system-setting/public-sentiment-key-setting',
          component: () =>
            import(
              '@/views/admin/system-setting/public-sentiment-key-setting/index'
            ),
        },
      ],
    },
  ],
}
